/* global scoringCriteriaIndexUrl scoringCriteriaUpdateUrl canEdit */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ScoringCriteriaIndexTable from './ScoringCriteriaIndexTable';

export default function ScoringCriteriaIndex(props) {
    return <ScoringCriteriaIndexTable fetchUrl={scoringCriteriaIndexUrl} updateUrl={scoringCriteriaUpdateUrl} canEdit={canEdit}></ScoringCriteriaIndexTable>;
}

if (document.getElementById('scoringCriteriaIndex')) {
    var root = document.getElementById('scoringCriteriaIndex');
    ReactDOM.render(
        <App>
            <ScoringCriteriaIndex />
        </App>,
        root,
    );
}
